module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D14-clean-6d486924908a4de464042269ff891b36.png";